// React libraries
import React from 'react';
// Component Style
import { useStyles } from './CreatableStyles';
// Assets
import { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Color } from '../../constants';
import { Close } from '../../sap_icons';
export const Creatable = (props) => {
    const { id, disabled, style, initialValue, setInitialValue, placeholder, color } = props;
    const classes = useStyles(props);
    const handleChange = (newValue, actionMeta) => {
        setInitialValue(newValue);
    };
    const onMouseEnter = (e) => {
        e.target.parentElement.style.background = 'transparent';
        e.target.parentElement.parentElement.style.background = Color.danger[300];
    };
    const onMouseLeave = (e) => {
        e.target.parentElement.style.background = 'transparent';
        e.target.parentElement.parentElement.style.background = Color.gradient[100];
    };
    const MultiValueRemove = props => {
        return (React.createElement(components.MultiValueRemove, Object.assign({}, props),
            React.createElement(Close, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: classes.multiValueRemove })));
    };
    return (React.createElement("div", { style: style, id: id },
        React.createElement(CreatableSelect, { isMulti: true, components: { MultiValueRemove }, onChange: handleChange, isDisabled: disabled, defaultValue: initialValue, placeholder: placeholder, styles: useStyles(color) })));
};
Creatable.defaultProps = {
    disabled: false,
    placeholder: "Select...",
    color: "grey"
};
export default React.memo(Creatable);
